import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  paper: {
    borderRadius: 12,
    maxWidth: 420,
    width: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '32px 28px 12px',
  },
  iconWrap: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: '#FFF4E5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
    flexShrink: 0,
  },
  icon: {
    color: '#ED6C02',
    fontSize: 26,
  },
  title: {
    fontWeight: 600,
    fontSize: 18,
    marginBottom: 8,
    color: '#1A1A1A',
  },
  message: {
    color: '#5F6368',
    fontSize: 14,
    lineHeight: '20px',
  },
  actions: {
    padding: '20px 28px 28px',
    justifyContent: 'center',
    gap: 12,
  },
  stayButton: {
    textTransform: 'none',
    fontWeight: 500,
    borderRadius: 6,
    padding: '8px 20px',
    border: '1px solid #3F51B5',
    color: '#3F51B5',
    backgroundColor: '#fff',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#F0F1FB',
      boxShadow: 'none',
    },
  },
  leaveButton: {
    textTransform: 'none',
    fontWeight: 500,
    borderRadius: 6,
    padding: '8px 20px',
    backgroundColor: '#D32F2F',
    color: '#fff',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#B71C1C',
      boxShadow: 'none',
    },
  },
}));

export default useStyles;
